var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeProtectionTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h4v38H50v-4h12V28zm4-17l-3.39 3L66 17v3h2v3H53v-3h2v-3l3.39-3L55 11V8h-2V5h15v3h-2v3zm-5.5 5.1L58 18.32V20h5v-1.68l-2.5-2.22zM63 8h-5v1.68l2.5 2.18L63 9.68V8zM10 66h16v-4H14V18h12v-4H10v52z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_protection_timer.7f0f6334.svg";
export { SvgF1ModeProtectionTimer as ReactComponent };